export default __webpack_public_path__ + "static/media/section1-bg1.0bbc286d.png";